module.exports = __webpack_public_path__ + "img/title-bg.c2be04e8.png";